export default __webpack_public_path__ + "static/banner-985ab03768afef3b01bae550766be9c9.svg";